let graphicLayer;
import TerrainClipPlan from "@/mapUtils/TerrainClipPlan";
export default {
  components: {},
  props: {},
  data() {
    return {
      drawLine_show: true,
      isFold: false,
    };
  },
  mounted() {
    // this.$refs["multipleTable"].$nextTick(function () {
    //            this.escrollY(
    //              ".el-table__body-wrapper",
    //              ".el-table__header-wrapper"
    //            );
    // 		   console.log('触发！');
    //          })
    if (!graphicLayer) {
      graphicLayer = new mars3d.layer.GraphicLayer();
      this.$GLOBAL.map.addLayer(graphicLayer);
    }
  },
  methods: {
    drawLineBox_close() {
      //this.drawLineTable_show=false;
      //alert("触发");
      // alert('触发！');
      this.$emit("drawLineBox_close");
    },
    drawLine_polyLine() {
      //开始绘制
      graphicLayer.startDraw({
        type: "polyline",
        // maxPointNum: 2, //可以限定最大点数，2个点绘制后自动结束
        style: {
          color: "#55ff33",
          width: 3,
          clampToGround: true,
        },
      });
    },
    drawLine_polygons() {
      //开始绘制
      graphicLayer.startDraw({
        type: "polyline",
        style: {
          color: "#ff0000",
          width: 3,
          closure: true,
          clampToGround: true,
        },
        success: (graphic) => {
          this.zhang(graphic);
        },
      });
    },
    drawLine_circle() {
      //开始绘制
      graphicLayer.startDraw({
        type: "circle",
        style: {
          color: "#16f3b8",
          opacity: 0.6,
          clampToGround: true,
          outline: true,
          outlineWidth: 3,
          outlineColor: "#ffffff",
        },
      });
    },
    drawLine_rectangle() {
      //开始绘制
      graphicLayer.startDraw({
        type: "rectangle",
        style: {
          color: "#49d4fb",
          opacity: 0.6,
          outline: true,
          outlineWidth: 3,
          outlineColor: "#ffffff",
          clampToGround: true,
        },
      });
    },
    drawLine_clear() {
      graphicLayer.clear();
    },
  },
  destroyed() {
    //alert(1);
    this.$GLOBAL.map.removeLayer(graphicLayer, true);
    graphicLayer = null;
  },
  watch: {},
};
//console.log(localStorage.getItem(ColorPicker));
